import React from "react";
import "./legal.css";
import Footer from "./Footer";

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last Updated: June 18, 2026</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            KostPadi (“we”, “our”, or “us”) is committed to protecting the
            privacy and personal data of our users in compliance with the
            Nigeria Data Protection Act (NDPA) 2023 and other applicable data
            protection laws.
          </p>

          <p>
            This Privacy Policy explains how we collect, use, process, store,
            disclose, and protect your information when you use the KostPadi
            platform.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>

          <h3>Personal Information</h3>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Business/company information</li>
            <li>Billing information</li>
          </ul>

          <h3>Business Data</h3>
          <ul>
            <li>Invoices</li>
            <li>Customer records</li>
            <li>Accounting records</li>
            <li>Financial reports</li>
            <li>Inventory data</li>
          </ul>

          <h3>Technical Information</h3>
          <ul>
            <li>IP address</li>
            <li>Browser information</li>
            <li>Device information</li>
            <li>Cookies and analytics data</li>
          </ul>
        </section>

        <section>
          <h2>3. Legal Basis for Processing</h2>

          <p>We process personal data based on:</p>

          <ul>
            <li>User consent</li>
            <li>Contractual necessity</li>
            <li>Legal obligations</li>
            <li>Legitimate business interests</li>
          </ul>
        </section>

        <section>
          <h2>4. How We Use Your Information</h2>

          <ul>
            <li>Provide and maintain KostPadi services</li>
            <li>Create and manage user accounts</li>
            <li>Process payments and subscriptions</li>
            <li>Generate invoices and reports</li>
            <li>Improve platform functionality</li>
            <li>Provide customer support</li>
            <li>Send service-related communications</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>5. Data Sharing & Third-Party Providers</h2>

          <p>
            We may share data with trusted third-party providers strictly for
            operational purposes:
          </p>

          <ul>
            <li>Supabase — database and authentication services</li>
            <li>Paystack — payment processing</li>
            <li>OpenAI — AI assistant functionality</li>
            <li>Vercel — hosting and deployment infrastructure</li>
            <li>Google Analytics — analytics and performance monitoring</li>
          </ul>

          <p>
            These providers process data under their respective privacy and
            security obligations.
          </p>
        </section>

        <section>
          <h2>6. International Data Transfers</h2>

          <p>
            Some of our third-party providers may process data outside Nigeria.
            Where this occurs, we implement appropriate safeguards to ensure
            adequate data protection standards.
          </p>
        </section>

        <section>
          <h2>7. Data Retention</h2>

          <p>
            We retain user data only for as long as necessary to provide
            services, comply with legal obligations, resolve disputes, and
            enforce agreements.
          </p>
        </section>

        <section>
          <h2>8. Your Rights</h2>

          <p>
            Under applicable data protection laws, users may have rights to:
          </p>

          <ul>
            <li>Access personal data</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of data</li>
            <li>Withdraw consent</li>
            <li>Object to processing</li>
            <li>Request data portability</li>
          </ul>
        </section>

        <section>
          <h2>9. Security Measures</h2>

          <p>
            We implement reasonable administrative, technical, and
            organizational safeguards to protect user data from unauthorized
            access, disclosure, alteration, or destruction.
          </p>
        </section>

        <section>
          <h2>10. Contact Information</h2>

          <p>For privacy-related inquiries, contact:</p>

          <p>Email: support@kostpadi.com</p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
